import { z } from 'zod'

export const SkuCreateFormSchema = z.object({
  name: z.string().min(1, {
    message: 'catalog.products.detail.skus.create.form.name.required',
  }),
  code: z.string().min(1, {
    message: 'catalog.products.detail.skus.create.form.code.required',
  }),
})

export type SkuCreateFormValues = z.infer<typeof SkuCreateFormSchema>
